import React from 'react';
import { Tab } from '@mui/material';
import { NavLink } from 'react-router-dom';

// Renders a single MUI <Tab>. It is intentionally a thin wrapper that returns a
// <Tab> *directly* (no Fragment, no surrounding Box) so that it can be a direct
// child of <Tabs>. MUI v9's Tabs clones its children and runs roving-tabindex /
// indicator measurement over them; anything other than a Tab (a Box, or a
// Fragment that renders extra nodes) makes that logic loop forever, throwing
// React error #185 ("Maximum update depth exceeded"). The dropdown <Menu> for
// "group" items is rendered separately by NavBarDropdownMenu, outside <Tabs>.
function NavbarLinkTab({ label, hideLabel, menuItems = [], onOpenMenu, ...props }: any) {
  const hasMenu = menuItems.length > 0;

  return (
    <Tab
      component={NavLink}
      iconPosition="start"
      label={hideLabel ? '' : label}
      {...props}
      sx={{
        color: (theme: any) => theme.palette.text.primary,
        height: 64,
        minHeight: 64,
        px: 3,
        '&:hover': {
          backgroundColor: (theme: any) => theme.palette.grey[100],
        },
      }}
      {...(hasMenu && {
        'aria-controls': `navbar-menu-items-${props.value}`,
        'aria-haspopup': 'true',
        onClick: (event: React.MouseEvent<HTMLElement>) => {
          // Group tabs only toggle their dropdown; they must not navigate.
          event.preventDefault();
          onOpenMenu?.(event.currentTarget);
        },
      })}
    />
  );
}

export default NavbarLinkTab;
